import React from "react";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import { columns } from "./utils";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  HeaderFilter,
  Sorting,
  Editing
} from "devextreme-react/data-grid";
import {
  addModuleCriterionAction,
  updateModuleCriterionAction,
  deleteModuleCriterionAction
} from "../../../../../store/actions";

const ElectronicResource = ({
  allModuleCriterionList,
  addCriterion,
  updateCriterion,
  deleteCriterion
}) => {
  const createCriterion = data => {
    const newCriterion = {
      main: {
        criterion: data.criterion,
        result: data.result
      }
    };
    addCriterion(newCriterion);
  };

  const updatedCriterion = data => {
    const updatedCriterion = {
      main: {
        criterion: data.criterion,
        result: data.result
      }
    };
    updateCriterion(data.id, updatedCriterion);
  };

  return (
    <div>
      <Box>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          wordWrapEnabled
          errorRowEnabled={false}
          showBorders
          dataSource={allModuleCriterionList}
          onRowInserted={event => createCriterion(event.data)}
          onRowUpdated={event => updatedCriterion(event.data)}
          onRowRemoved={event => deleteCriterion(event.data.id)}
        >
          {columns.map((column, idx) => (
            <Column key={idx} {...column} defaultSortOrder="asc" />
          ))}
          <Editing mode="row" allowUpdating allowDeleting allowAdding />
          <Sorting showSortIndexes={false} visible />
          <HeaderFilter visible />
          <FilterRow visible />
          <Scrolling mode="virtual" />
          <LoadPanel enabled />
        </DataGrid>
      </Box>
    </div>
  );
};

const mapStateToProps = state => ({
  allModuleCriterionList: state.modules.allModuleCriterionList
});

const mapDispatchToProps = dispatch => ({
  addCriterion: site => dispatch(addModuleCriterionAction(site)),
  updateCriterion: (idCriterion, data) =>
    dispatch(updateModuleCriterionAction(idCriterion, data)),
  deleteCriterion: idCriterion =>
    dispatch(deleteModuleCriterionAction(idCriterion))
});

export default connect(mapStateToProps, mapDispatchToProps)(ElectronicResource);
